<mat-dialog-content>
    {{message}}
</mat-dialog-content>
<mat-dialog-actions align="center">
<button mat-raised-button color="primary" style="align-content: center;" mat-dialog-close tabindex="-1">{{cancelButtonText}}</button>

</mat-dialog-actions>